const mediaItems = [
  {
    title: '2026夏季新番导览',
    desc: '本季最值得关注的15部新番动画，从热血战斗到治愈日常一网打尽',
    duration: '12:30',
    image: 'https://readdy.ai/api/search-image?query=Summer%20anime%20season%20collage%20with%20vibrant%20character%20illustrations%20from%20various%20new%20shows%2C%20colorful%20dynamic%20composition%2C%20warm%20sunny%20summer%20vibes%2C%20playful%20anime%20art%20style%2C%20cream%20and%20coral%20accents%2C%20exciting%20preview%20atmosphere&width=800&height=450&seq=51anime-media-01&orientation=landscape',
  },
  {
    title: '国漫十年发展回顾',
    desc: '从《秦时明月》到《斗破苍穹》，中国动画产业的崛起之路',
    duration: '18:45',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20evolution%20timeline%20visual%20with%20classic%20to%20modern%20animation%20styles%2C%20traditional%20ink%20art%20blending%20into%20digital%203D%2C%20warm%20golden%20and%20coral%20lighting%2C%20inspirational%20retrospective%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=51anime-media-02&orientation=landscape',
  },
  {
    title: '热血漫入坑指南',
    desc: '从未看过动漫？这份入门推荐清单带你快速进入精彩的二次元世界',
    duration: '08:20',
    image: 'https://readdy.ai/api/search-image?query=Beginner%20anime%20guide%20visual%20with%20iconic%20shonen%20protagonists%20in%20dynamic%20poses%2C%20friendly%20welcoming%20atmosphere%2C%20bright%20warm%20colors%2C%20engaging%20educational%20tone%2C%20clean%20illustrative%20style%2C%20cream%20background%20with%20coral%20highlights&width=800&height=450&seq=51anime-media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精彩看点</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            动漫资讯与专题内容，带您深入了解每一部作品背后的故事
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/80 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-play-fill text-3xl ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-background-950/70 text-background-50 text-xs rounded">{item.duration}</div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}